import { FaGavel, FaUniversity,FaTshirt, FaCar, FaHeartbeat, FaGraduationCap, FaSuitcaseRolling,  FaBuilding,FaTools} from "react-icons/fa";

const industries = [
 {
  id: 1,
  title: "Legal",
  slug: "legal",
  segment: "Professional Services",
  summary:
    "We help law firms and solo attorneys build credibility, attract high-intent clients, and streamline intake with conversion-focused websites, local SEO, compliant lead gen, and secure client portals.",
  icon: {
    
    reactIcons: FaGavel,
    lucide: "Scale"
  },
  brand: {
    color: "#FFFFFF",
    accent: "#FFFFFF",
    gradient: "linear-gradient(135deg, #FFFFFF 0%, #FFFFFF 100%)"
    
  },

  hero: {
    headline: "Build Trust. Win Cases. Grow Your Law Firm.",
    subheadline:
      "Conversion-ready legal websites, local SEO, and secure intake systems designed to bring qualified clients to your practice.",
    highlights: [
      { label: "Avg. Lead Uplift", value: "2.4x" },
      { label: "PageSpeed Score", value: "90+" },
      { label: "Intake Automations", value: "12+" }
    ],
    primaryButton: { label: "Get a Free Strategy Call", href: "/contact?src=legal" },
    secondaryButton: { label: "See Work & Results", href: "/case-studies?industry=legal" },
    badge: "For Law Firms & Solo Practitioners"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Courtroom bench with scales of justice and law books",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1555375771-14b2f1df4e86?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Attorney consulting a client in office"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1528747045269-390fe33c19d8?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Law library shelves with leather-bound books"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Team of legal professionals planning strategy"
  //     }
  //   ]
  // },

  painPoints: [
    "High competition on local search for practice-area keywords.",
    "Inefficient client intake and missed inquiries after hours.",
    "Low trust signals (few reviews, thin attorney bios, lack of case results).",
    "Slow, outdated sites that underperform on mobile.",
    "Compliance and data-privacy concerns for forms and documents.",
    "Difficulty tracking ROI across calls, forms, and chats."
  ],

  solutions: {
    websiteExperience: [
      "Authority-focused site architecture by practice area (e.g., Family, Corporate, Criminal, IP).",
      "Attorney & team profiles with credentials, bar numbers, awards, and associations.",
      "Case results, testimonials, and FAQs to reduce friction and boost trust.",
      "Fast, accessible, mobile-first UX with 90+ Lighthouse and Core Web Vitals."
    ],
    marketingGrowth: [
      "Local SEO: Google Business Profile optimization, map pack strategy, reviews engine.",
      "High-intent PPC for practice-area keywords with call-only variants and ad extensions.",
      "Content marketing: topical clusters (FAQs, statutes, processes) and E-E-A-T signals.",
      "Retargeting via display and social to recapture comparison shoppers."
    ],
    operations: [
      "Secure intake forms with file uploads, e-sign triggers, and calendar booking.",
      "Call tracking, form attribution, and CRM pipelines by practice area.",
      "Automated follow-ups: SMS/email sequences for missed calls and new inquiries.",
      "Role-based dashboards for partners, associates, and intake staff."
    ],
    compliancePrivacy: [
      "HTTPS, TLS, WAF, DDoS protection, spam filtering, and encrypted at-rest storage.",
      "Cookie consent + privacy policy, data-retention controls.",
      "Least-privilege access and audit logs for intake data.",
      "Backups and disaster recovery playbooks."
    ]
  },

  services: [
    {
      title: "Legal Website Design & Development",
      description:
        "Authority-driven, conversion-optimized websites crafted for legal credibility and lead generation.",
      deliverables: [
        "Practice-area landing pages",
        "Attorney bios & credentials",
        "Case results & testimonials",
        "Secure intake forms & booking",
        "Blog/Insights hub",
        "Accessibility (WCAG 2.2 AA)"
      ],
      icon: "FaBalanceScale",
      duration: "4–8 weeks",
      startingPriceINR: 150000
    },
    {
      title: "Local SEO for Law Firms",
      description:
        "Rank in the map pack and organic results for your practice areas and service locations.",
      deliverables: [
        "Google Business Profile optimization",
        "Citation management & NAP consistency",
        "Review generation system",
        "On-page & internal linking",
        "Schema markup (LegalService, FAQ, HowTo)"
      ],
      icon: "FaSearchLocation",
      duration: "Ongoing (3–6 months to compounding)",
      startingPriceINR: 40000
    },
    {
      title: "Legal PPC (Search & Call-Only)",
      description:
        "High-intent ads for keywords like 'divorce lawyer near me' with call-tracking and ROI visibility.",
      deliverables: [
        "Keyword & negative list strategy",
        "Ad copy & extensions",
        "Conversion tracking (calls/forms/chats)",
        "Landing pages & A/B testing",
        "Weekly performance reports"
      ],
      icon: "FaBullseye",
      duration: "Ongoing (monthly)",
      startingPriceINR: 35000
    },
    {
      title: "Content & Thought Leadership",
      description:
        "Demonstrate expertise with FAQs, guides, and jurisdiction-specific explainers that build E-E-A-T.",
      deliverables: [
        "Topic clusters & content calendar",
        "Attorney-bylined articles",
        "Case study and result pages",
        "Internal linking & schema",
        "Repurposing for social & email"
      ],
      icon: "FaPenFancy",
      duration: "Ongoing (monthly)",
      startingPriceINR: 30000
    },
    {
      title: "Secure Intake & CRM Automation",
      description:
        "Never miss a lead: unified intake with alerts, automated follow-ups, and pipeline tracking.",
      deliverables: [
        "Secure forms with file upload",
        "Calendar & e-sign triggers",
        "SMS/email sequences for no-shows",
        "Pipeline & stage automations",
        "Attribution dashboards"
      ],
      icon: "FaUserShield",
      duration: "2–4 weeks",
      startingPriceINR: 60000
    }
  ],

  features: {
    mustHave: [
      "Practice-area pages with FAQs and trust badges",
      "Attorney/team profiles with credentials",
      "Map, directions, service areas, and hours",
      "Click-to-call, WhatsApp, and instant callback",
      "Secure intake with document upload"
    ],
    niceToHave: [
      "Live chat or chatbot with screening",
      "Client portal for document sharing",
      "Multilingual content (EN/BN/HI as needed)",
      "Video explainers and walkthroughs",
      "Knowledge base with filters and search"
    ]
  },

  integrations: [
    { name: "Google Business Profile", category: "Local SEO" },
    { name: "CallRail / PhonPe Trackers", category: "Call Tracking" },
    { name: "HubSpot / Zoho CRM / Clio Manage", category: "CRM" },
    { name: "Calendly / Cal.com", category: "Scheduling" },
    { name: "Razorpay / Stripe", category: "Payments & Retainers" },
    { name: "SendGrid / Brevo", category: "Email & SMTP" },
    { name: "Twilio / WhatsApp Business API", category: "SMS/WhatsApp" },
    { name: "Google Analytics 4 + Consent Mode", category: "Analytics" },
    { name: "Cloudflare", category: "Security & CDN" }
  ],

  techStack: {
    frontend: ["Next.js (React)", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "Express or NestJS"],
    cms: ["Sanity", "Strapi"],
    database: ["PostgreSQL", "MongoDB"],
    search: ["Algolia (optional)"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "GTM", "PostHog (optional)"],
    testing: ["Playwright", "Lighthouse CI"],
    formsSecurity: ["reCAPTCHA v3", "Honeypots", "WAF rules"]
  },

  process: [
    {
      step: 1,
      title: "Discovery & Positioning",
      duration: "3–5 days",
      outputs: ["Practice taxonomy", "Value proposition", "KPI plan"]
    },
    {
      step: 2,
      title: "Information Architecture & Wireframes",
      duration: "1–2 weeks",
      outputs: ["Sitemap", "Wireframes", "Content outline"]
    },
    {
      step: 3,
      title: "Design System & UI",
      duration: "1–2 weeks",
      outputs: ["UI kit", "Component library", "Mobile-first screens"]
    },
    {
      step: 4,
      title: "Development & Integrations",
      duration: "2–3 weeks",
      outputs: ["Responsive pages", "CMS & CRM", "Automations"]
    },
    {
      step: 5,
      title: "SEO, Content & Launch",
      duration: "1 week",
      outputs: ["On-page SEO", "Schema", "QA & Lighthouse >90"]
    },
    {
      step: 6,
      title: "Growth & Optimization",
      duration: "Ongoing",
      outputs: ["A/B tests", "Content cadence", "Monthly reports"]
    }
  ],

  kpis: [
    "Qualified lead volume (calls/forms/chats) per practice area",
    "Cost per qualified lead (PPC + organic blended)",
    "First response time and booking rate",
    "Local rankings (map pack, organic) for target queries",
    "PageSpeed/Core Web Vitals and mobile UX scores"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Solo or small practice",
      priceINR: 120000,
      timeline: "3–4 weeks",
      includes: [
        "5–7 pages (Home, About, 3 Practice Areas, Contact)",
        "Secure intake form + WhatsApp",
        "On-page SEO & basic schema",
        "Google Business Profile setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Small–Mid Law Firm",
      priceINR: 220000,
      timeline: "5–7 weeks",
      includes: [
        "10–15 pages + Blog",
        "Local SEO + review engine",
        "CRM pipeline + call tracking",
        "Monthly performance report (3 months)"
      ]
    },
    {
      tier: "Scale",
      audience: "Multi-location firm",
      priceINR: 380000,
      timeline: "7–10 weeks",
      includes: [
        "20+ pages with multilingual support",
        "Advanced PPC & landing pages",
        "Client portal + e-sign triggers",
        "Content program & monthly CRO"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Raj & Associates (Family Law)",
      location: "Kolkata",
      goals: ["Increase consult bookings", "Reduce no-shows"],
      outcomes: [
        "Leads up 2.8× in 90 days",
        "Map pack Top-3 for 7 core terms",
        "No-shows down 34% via SMS reminders"
      ],
      stack: ["Next.js", "Sanity", "HubSpot", "Call tracking"]
    }
  ],

  testimonials: [
    {
      author: "Adv. Priya Mehta",
      role: "Partner, PM Legal",
      quote:
        "They transformed our intake. We respond faster, rank locally, and our bookings have doubled without adding staff."
    }
  ],

  faqs: [
    {
      q: "How long does a legal website project take?",
      a: "Most firms launch in 4–8 weeks depending on scope, content readiness, and integrations."
    },
    {
      q: "Can you migrate my existing content and preserve SEO?",
      a: "Yes. We redirect legacy URLs, map keywords, carry over schema, and protect rankings during the move."
    },
    {
      q: "Do you support multilingual sites?",
      a: "Yes. We can deliver multilingual setups (e.g., English, Bengali, Hindi) with proper hreflang and localized SEO."
    },
    {
      q: "Is my client data secure?",
      a: "We use HTTPS/TLS, hardened servers, role-based access, encrypted storage, and audit logs. Forms use anti-spam and WAF rules."
    },
    {
      q: "How do you measure success?",
      a: "We track qualified leads (calls, forms, chats), booking rates, local rankings, cost per lead, and site performance."
    },
    {
      q: "Do you provide content writing for legal topics?",
      a: "Yes. We produce attorney-reviewed content aligned with jurisdictional nuances and practice-area search intent."
    },
    {
      q: "What budgets should we plan for ads?",
      a: "For competitive metros, many firms start ₹40k–₹1.2L/month on PPC and scale once cost-per-lead targets are met."
    },
    {
      q: "Will you manage reviews and Google Business Profile?",
      a: "Yes. We implement a compliant review engine, monitor GBP, and optimize to win the map pack."
    }
  ],

  cta: {
    title: "Ready to attract more qualified clients?",
    text:
      "Let’s craft a legal marketing engine that combines trust, speed, and measurable growth.",
    primaryButton: { label: "Book Your Strategy Call", href: "/contact?plan=strategy" },
    secondaryButton: { label: "Download Legal Website Checklist", href: "/resources/legal-website-checklist.pdf" }
  },

  seo: {
    metaTitle: "Legal Marketing & Law Firm Websites | High-Intent Leads & Secure Intake",
    metaDescription:
      "Law firm websites, local SEO, PPC, and secure intake systems. Faster sites, more consults, measurable ROI. For solo attorneys and multi-location firms.",
    keywords: [
      "law firm website design",
      "legal marketing",
      "local SEO for lawyers",
      "attorney lead generation",
      "secure client intake"
    ],
    canonical: "https://merndigital.com/industries/legal",
    og: {
      title: "Grow Your Law Firm with High-Intent Leads",
      description:
        "Conversion-ready legal websites, local SEO, and secure intake to win more cases.",
      // image:"https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    // you can JSON.stringify() this for <script type="application/ld+json">
    organization: {
      "@context": "https://schema.org",
      "@type": "LegalService",
      name: "Mern Digital — Legal Marketing",
      url: "https://merndigital.com/industries/legal",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.google.com/maps", "https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does a legal website project take?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Most firms launch in 4–8 weeks depending on scope, content readiness, and integrations."
          }
        },
        {
          "@type": "Question",
          name: "Do you support multilingual sites?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes. We can deliver multilingual setups with proper hreflang and localized SEO."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/legal",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Legal",
        "item":"https://merndigital.com/industries/legal"
      }]
    }
  },

  localization: {
    languages: ["en", "bn", "hi"],
    default: "en"
  }
 }  ,
{
  id: 3,
  title: "Financial Services",
  slug: "financial-services",
  segment: "Professional Services",
  summary:
    "We empower financial advisors, wealth managers, and fintech providers with secure, conversion-focused websites, client portals, and digital marketing strategies to build trust and scale growth.",
  icon: {
    reactIcons: FaUniversity, // can swap with FaPiggyBank or FaMoneyCheckAlt
    lucide: "Banknote"
  },
  brand: {
    color: "#1af207",
    accent: "#1af207",
    gradient: "linear-gradient(135deg, #1F4E79 0%, #102A43 100%)",
    
  },

  hero: {
    headline: "Build Trust. Grow Assets. Win Clients.",
    subheadline:
      "High-performing websites, secure portals, and marketing strategies that help financial service providers attract investors, clients, and long-term partnerships.",
    highlights: [
      { label: "Avg. Lead Growth", value: "2.5x" },
      { label: "Data Security", value: "A+" },
      { label: "Automation Savings", value: "15%" }
    ],
    primaryButton: { label: "Get a Free Strategy Call", href: "/contact?src=financial-services" },
    secondaryButton: { label: "See Client Success Stories", href: "/case-studies?industry=financial-services" },
    badge: "For Financial Advisors, Wealth Managers & Fintechs"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Financial advisor analyzing market performance with clients",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1522205161898-98b6f10c7c97?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Investor meeting with financial planner"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Wealth manager presenting growth charts"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1556742400-b5e8c9f2a9dd?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Financial services team reviewing portfolios"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty earning client trust without a strong digital presence.",
    "Low visibility for high-value financial keywords in search results.",
    "Complex client onboarding and compliance-heavy processes.",
    "Manual portfolio updates and client reporting.",
    "High acquisition costs due to ineffective digital campaigns.",
    "Security and compliance risks around sensitive financial data."
  ],

  solutions: {
    websiteExperience: [
      "Premium websites tailored for financial advisors, investment firms, and fintechs.",
      "Trust-building elements: certifications, licenses, and regulatory disclosures.",
      "Case studies, client testimonials, and market insights hub.",
      "Mobile-first, conversion-optimized designs."
    ],
    marketingGrowth: [
      "SEO for high-value terms like 'wealth manager near me' or 'retirement planning services'.",
      "PPC campaigns targeting investment and financial planning keywords.",
      "Content marketing: market insights, investment guides, and whitepapers.",
      "LinkedIn campaigns to attract HNIs and corporate clients."
    ],
    operations: [
      "Secure client portals for portfolio access and reporting.",
      "Automated client onboarding and KYC workflows.",
      "CRM integrations for client lifecycle management.",
      "Performance dashboards for ROI and retention tracking."
    ],
    compliancePrivacy: [
      "Bank-grade hosting with encryption, TLS, and SOC 2 compliance.",
      "Secure document storage with role-based access.",
      "Audit-ready logs and data residency controls.",
      "Cookie consent, GDPR/SEBI/FINRA aligned policies."
    ]
  },

  services: [
    {
      title: "Financial Services Website Design",
      description:
        "Build authority with credibility-driven websites optimized for lead generation and regulatory compliance.",
      deliverables: [
        "Service & solution landing pages",
        "Team bios with licenses & certifications",
        "Case studies & testimonials",
        "Investor education hub",
        "Secure client portals",
        "Regulatory compliance pages"
      ],
      icon: "FaGlobe",
      duration: "5–7 weeks",
      startingPriceINR: 150000
    },
    {
      title: "SEO for Financial Advisors",
      description:
        "Rank for competitive wealth management and investment terms with advanced on-page and local SEO.",
      deliverables: [
        "High-value keyword targeting",
        "Local & national SEO optimization",
        "Review and reputation management",
        "Schema & structured data implementation"
      ],
      icon: "FaSearch",
      duration: "Ongoing (4–6 months to compounding)",
      startingPriceINR: 40000
    },
    {
      title: "Financial PPC & LinkedIn Campaigns",
      description:
        "Reach high-net-worth clients and investors through targeted ad campaigns with optimized funnels.",
      deliverables: [
        "Keyword/audience targeting",
        "Ad creatives and copywriting",
        "Landing page design",
        "Conversion tracking dashboards"
      ],
      icon: "FaBullhorn",
      duration: "Ongoing (monthly)",
      startingPriceINR: 50000
    },
    {
      title: "Thought Leadership Content",
      description:
        "Establish authority with market insights, investment reports, and client-focused educational content.",
      deliverables: [
        "Content strategy",
        "Whitepapers & investment guides",
        "Client case studies",
        "Repurposed content for email & LinkedIn"
      ],
      icon: "FaBook",
      duration: "Ongoing (monthly)",
      startingPriceINR: 35000
    },
    {
      title: "Client Portal & Compliance Solutions",
      description:
        "Modernize financial operations with secure portals, automation, and compliance-ready systems.",
      deliverables: [
        "Secure investor portal",
        "Automated KYC & onboarding",
        "E-signature integrations",
        "Portfolio performance dashboards"
      ],
      icon: "FaLock",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    }
  ],

  features: {
    mustHave: [
      "Regulatory-compliant service pages",
      "Team credentials & licenses",
      "Secure investor/client portal",
      "Market insights/blog hub",
      "WhatsApp/Click-to-call integration"
    ],
    niceToHave: [
      "Investment calculators",
      "Chatbot for lead qualification",
      "Multilingual support",
      "Video explainers on investment strategies",
      "Downloadable research reports"
    ]
  },

  integrations: [
    { name: "Google Business Profile", category: "Local SEO" },
    { name: "Salesforce / Zoho CRM / HubSpot", category: "CRM" },
    { name: "QuickBooks / Zoho Books", category: "Finance" },
    { name: "DocuSign / Adobe Sign", category: "E-signatures" },
    { name: "Stripe / Razorpay", category: "Payments" },
    { name: "Brevo / Mailchimp", category: "Email Marketing" },
    { name: "Twilio / WhatsApp Business", category: "Client Communication" },
    { name: "GA4 + Consent Mode", category: "Analytics" },
    { name: "Cloudflare", category: "Security" }
  ],

  techStack: {
    frontend: ["Next.js (React)", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "NestJS"],
    cms: ["Sanity", "Strapi"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "PostHog", "GTM"],
    formsSecurity: ["reCAPTCHA v3", "WAF", "Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Compliance Review", duration: "1 week", outputs: ["Compliance requirements", "Service taxonomy", "KPI roadmap"] },
    { step: 2, title: "Information Architecture", duration: "1–2 weeks", outputs: ["Sitemap", "Wireframes", "Compliance pages"] },
    { step: 3, title: "Design & Branding", duration: "1–2 weeks", outputs: ["UI Kit", "Responsive layouts", "Investor trust signals"] },
    { step: 4, title: "Development & Integrations", duration: "2–3 weeks", outputs: ["Pages", "CRM & Portal", "Automation"] },
    { step: 5, title: "SEO & Launch", duration: "1 week", outputs: ["SEO setup", "Schema", "QA & Lighthouse >90"] },
    { step: 6, title: "Growth & Optimization", duration: "Ongoing", outputs: ["Reports", "A/B tests", "Content scaling"] }
  ],

  kpis: [
    "Qualified investor/lead volume",
    "Conversion rate from campaigns",
    "Client onboarding time reduction",
    "SEO rankings for wealth/investment terms",
    "Client portal adoption & usage"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Independent financial advisor",
      priceINR: 120000,
      timeline: "4–5 weeks",
      includes: [
        "5–7 pages (Home, About, Services, Contact)",
        "Basic SEO setup",
        "Compliance-ready disclosures",
        "Google Business Profile setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Small to mid-sized financial firm",
      priceINR: 230000,
      timeline: "6–8 weeks",
      includes: [
        "10–15 pages + Blog",
        "Local SEO & review management",
        "Client portal integration",
        "3 months reporting & optimization"
      ]
    },
    {
      tier: "Scale",
      audience: "Wealth management or fintech enterprise",
      priceINR: 380000,
      timeline: "8–10 weeks",
      includes: [
        "20+ pages with calculators & reports",
        "Advanced PPC & LinkedIn campaigns",
        "Secure investor portal & automation",
        "Multilingual support & CRO program"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Shakti Wealth Advisory",
      location: "Delhi",
      goals: ["Boost HNI acquisition", "Enhance digital trust"],
      outcomes: [
        "3× inbound leads in 6 months",
        "Top 5 ranking for 'wealth manager Delhi'",
        "Client onboarding time reduced by 60%"
      ],
      stack: ["Next.js", "Salesforce", "GA4", "DocuSign"]
    }
  ],

  testimonials: [
    {
      author: "Anita Verma",
      role: "Founder, Verma Wealth",
      quote:
        "The secure client portal and professional website gave our firm the credibility it needed. Our lead flow doubled within 4 months."
    }
  ],

  faqs: [
    {
      q: "Do you build compliance-ready financial websites?",
      a: "Yes. We design websites with disclosures, disclaimers, and regulatory compliance for financial services."
    },
    {
      q: "Can you integrate secure investor portals?",
      a: "Absolutely. We provide encrypted, role-based client/investor portals for reporting and communication."
    },
    {
      q: "How do you help attract high-net-worth clients?",
      a: "Through SEO, PPC, and LinkedIn campaigns targeting relevant financial and wealth management search terms."
    },
    {
      q: "Do you support ongoing marketing?",
      a: "Yes. We provide SEO, PPC, content, and thought leadership programs for continuous growth."
    },
    {
      q: "Is client financial data secure?",
      a: "We use encryption, TLS, WAF protection, and compliance frameworks like SOC 2 and GDPR to ensure security."
    }
  ],

  cta: {
    title: "Ready to grow your financial services firm?",
    text:
      "Let’s build a secure, compliant, and growth-focused digital presence that builds trust and attracts investors.",
    primaryButton: { label: "Book a Free Strategy Session", href: "/contact?plan=financial" },
    secondaryButton: { label: "Download Financial Website Checklist", href: "/resources/financial-website-checklist.pdf" }
  },

  seo: {
    metaTitle: "Financial Services Websites | Secure Growth & Client Portals",
    metaDescription:
      "Websites, SEO, PPC, and secure portals for financial advisors and wealth managers. Build trust, attract investors, and streamline operations.",
    keywords: [
      "financial advisor website design",
      "wealth management websites",
      "SEO for financial services",
      "client portal for wealth managers",
      "digital marketing for financial advisors"
    ],
    canonical: "https://merndigital.com/industries/financial-services",
    og: {
      title: "Grow Your Financial Services Firm",
      description:
        "Websites, SEO, PPC, and secure client portals designed to build trust and attract investors.",
      // image:"https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      name: "Mern Digital — Financial Services Solutions",
      url: "https://merndigital.com/industries/financial-services",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.google.com/maps", "https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build compliance-ready financial websites?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes. We design websites with disclosures, disclaimers, and regulatory compliance for financial services."
          }
        },
        {
          "@type": "Question",
          name: "Can you integrate secure investor portals?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. We provide encrypted, role-based client/investor portals for reporting and communication."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/financial-services",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Financial Services",
        "item":"https://merndigital.com/industries/financial-services"
      }]
    }
  },

  localization: {
    languages: ["en", "bn", "hi"],
    default: "en"
  }
},
{
  id: 7,
  title: "Travel & Tourism",
  slug: "travel-tourism",
  segment: "Technology",
  summary:
    "We create digital solutions for travel agencies, tour operators, and online booking platforms—helping manage bookings, automate workflows, and enhance customer experiences across all touchpoints.",
  icon: {
    reactIcons: FaSuitcaseRolling, // travel / tourism icon
    lucide: "Globe"
  },
  brand: {
    color: "#00ACC1",
    accent: "#26C6DA",
    gradient: "linear-gradient(135deg, #00ACC1 0%, #26C6DA 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Travel & Tourism",
    subheadline:
      "From online booking platforms to itinerary management, we help travel agencies streamline operations, increase bookings, and delight customers worldwide.",
    highlights: [
      { label: "Booking Efficiency", value: "3x" },
      { label: "Customer Satisfaction", value: "95%" },
      { label: "Operational Automation", value: "60%" }
    ],
    primaryButton: { label: "Book a Travel Tech Consultation", href: "/contact?src=travel-tourism" },
    secondaryButton: { label: "See Travel Case Studies", href: "/case-studies?industry=travel-tourism" },
    badge: "For Travel Agencies, Tour Operators & Online Booking Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Travel agency dashboard with booking interface",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Tour operator planning itineraries"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1519817650390-64a93db511c6?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online travel booking dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Travel agency team interacting with clients"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual booking and reservation management.",
    "Difficulty tracking customer preferences and itineraries.",
    "High operational costs due to redundant tasks.",
    "Limited visibility into sales and commissions.",
    "Slow response to customer inquiries.",
    "Difficulty integrating multiple booking and payment platforms."
  ],

  solutions: {
    operations: [
      "Centralized booking and reservation management.",
      "Automated itinerary generation and updates.",
      "CRM for customer preferences and travel history.",
      "Online payment and invoicing automation."
    ],
    integrations: [
      "Integrate with flight, hotel, and tour providers.",
      "API integration with payment gateways.",
      "Email and SMS notifications for bookings and reminders.",
      "Integration with travel review platforms and loyalty programs."
    ],
    analytics: [
      "Booking trends and revenue dashboards.",
      "Customer segmentation and personalization analytics.",
      "Performance tracking for agents and teams.",
      "Forecasting demand and seasonal trends."
    ],
    customerExperience: [
      "Online booking portals and mobile apps.",
      "Automated confirmations and reminders.",
      "Customer support chatbots and ticketing.",
      "Custom travel recommendations based on preferences."
    ]
  },

  services: [
    {
      title: "Custom Travel Booking Platform",
      description:
        "Build a platform for flights, hotels, tours, and holiday packages with real-time availability and automated pricing.",
      deliverables: [
        "Booking engine",
        "Payment gateway integration",
        "Admin dashboard & reporting",
        "Mobile app for customers"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Travel CRM & Customer Portal",
      description:
        "Manage customer profiles, preferences, and travel history with a dedicated CRM system.",
      deliverables: [
        "Customer profiles & segmentation",
        "Itinerary tracking",
        "Loyalty & rewards integration",
        "Automated communication workflows"
      ],
      icon: "FaUsersCog",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Travel Integrations",
      description:
        "Connect your system with flight, hotel, and tour APIs, along with payment gateways and review platforms.",
      deliverables: [
        "Booking APIs integration",
        "Payment & invoicing setup",
        "Third-party review & rating systems",
        "Automated email/SMS alerts"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Advanced dashboards for booking trends, revenue, and agent performance.",
      deliverables: [
        "Revenue & sales analytics",
        "Agent performance reports",
        "Customer trends analysis",
        "Forecasting & demand insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Booking & reservation management",
      "Customer profile tracking",
      "Payment & invoicing automation",
      "Itinerary management",
      "Custom reports & dashboards"
    ],
    niceToHave: [
      "AI-based travel recommendations",
      "Mobile app for customers",
      "Loyalty program integration",
      "Chatbot support",
      "Dynamic pricing & offers"
    ]
  },

  integrations: [
    { name: "Flight & Hotel APIs (Amadeus, Sabre, Expedia)", category: "Travel Providers" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "CRM Platforms (Salesforce, Zoho)", category: "Customer Management" },
    { name: "Travel Review Platforms (TripAdvisor, Google Reviews)", category: "Customer Feedback" },
    { name: "Power BI / Tableau", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Booking flow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Booking modules", "Payment APIs", "Admin dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Booking conversion rate",
    "Customer satisfaction score",
    "Average booking value",
    "Agent performance",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small travel agencies",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic booking engine",
        "Customer profiles",
        "Payment gateway integration",
        "Basic reporting"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized travel agencies & tour operators",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom booking modules",
        "Itinerary management",
        "Multi-agent roles",
        "Advanced reporting & analytics"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large travel platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full booking platform",
        "AI-based recommendations",
        "Loyalty & rewards integration",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Wanderlust Travels",
      location: "Bangalore",
      goals: ["Automate bookings", "Increase customer retention"],
      outcomes: [
        "Booking process automated by 70%",
        "Customer satisfaction increased to 95%",
        "Revenue per agent increased by 2x"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Priya Menon",
      role: "Founder, Wanderlust Travels",
      quote:
        "The travel platform transformed our agency operations. Bookings are faster, customers are happier, and our team productivity has skyrocketed."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with flight and hotel booking APIs?",
      a: "Yes, we integrate with popular travel APIs like Amadeus, Sabre, and Expedia for real-time booking."
    },
    {
      q: "Do you provide CRM for customer management?",
      a: "Absolutely. Our platform manages customer profiles, preferences, travel history, and loyalty programs."
    },
    {
      q: "Can this system handle multiple agents and offices?",
      a: "Yes, the platform supports multi-agent roles, permissions, and multi-office setups."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide long-term support, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to digitize your travel agency?",
    text:
      "Let’s build a platform that automates bookings, improves customer experience, and scales your travel business.",
    primaryButton: { label: "Book a Free Travel Consultation", href: "/contact?plan=travel" },
    secondaryButton: { label: "Download Travel Agency Tech Guide", href: "/resources/travel-guide.pdf" }
  },

  seo: {
    metaTitle: "Travel Agency Software & Booking Platform Solutions | Optimize Operations",
    metaDescription:
      "We build custom software for travel agencies and tour operators—online booking, itinerary management, CRM, and analytics.",
    keywords: [
      "Travel software",
      "Tour operator platform",
      "Online booking system",
      "Travel CRM",
      "Itinerary management"
    ],
    canonical: "https://merndigital.com/industries/travel-tourism",
    og: {
      title: "Travel & Tourism Software Solutions",
      description: "Custom platforms for travel agencies and tour operators.",
      // image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Travel & Tourism Solutions",
      url: "https://merndigital.com/industries/travel-tourism",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with flight and hotel booking APIs?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, we integrate with popular travel APIs like Amadeus, Sabre, and Expedia for real-time booking."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide CRM for customer management?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. Our platform manages customer profiles, preferences, travel history, and loyalty programs."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/travel-tourism",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Travel & Tourism",
       "item":"https://merndigital.com/industries/travel-tourism"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 8,
  title: "Real Estate & Property Management",
  slug: "real-estate",
  segment: "Technology",
  summary:
    "We deliver digital solutions for real estate agencies, property developers, and rental platforms—helping manage listings, automate property workflows, and enhance client engagement.",
  icon: {
    reactIcons: FaBuilding, // real estate icon
    lucide: "Home"
  },
  brand: {
    color: "#4CAF50",
    accent: "#81C784",
    gradient: "linear-gradient(135deg, #4CAF50 0%, #81C784 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Real Estate Management",
    subheadline:
      "From property listings to client management and automated workflows, we help real estate businesses streamline operations, attract clients, and close deals faster.",
    highlights: [
      { label: "Listing Efficiency", value: "3x" },
      { label: "Lead Conversion", value: "90%" },
      { label: "Operational Automation", value: "50%" }
    ],
    primaryButton: { label: "Book a Real Estate Tech Consultation", href: "/contact?src=real-estate" },
    secondaryButton: { label: "See Real Estate Case Studies", href: "/case-studies?industry=real-estate" },
    badge: "For Real Estate Agencies, Property Developers & Rental Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1560184897-6c3e4a126332?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Real estate management dashboard with property listings",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1572120360610-d971b9a4f53c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Property listings on a web portal"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1599423300746-b62533397364?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Real estate agents analyzing market data"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Property management team coordinating tasks"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual property listing management.",
    "Difficulty tracking leads and client communication.",
    "High administrative costs and redundant workflows.",
    "Limited visibility into sales performance.",
    "Slow response to property inquiries.",
    "Difficulty integrating multiple platforms for listings and CRM."
  ],

  solutions: {
    operations: [
      "Centralized property listing and management.",
      "CRM for lead tracking and client communication.",
      "Automated workflows for property approvals and rentals.",
      "Payment, invoicing, and rent collection automation."
    ],
    integrations: [
      "Integration with MLS, listing portals, and rental platforms.",
      "API integration with payment gateways.",
      "Email and SMS notifications for clients and tenants.",
      "Integration with analytics platforms for market insights."
    ],
    analytics: [
      "Sales and lead tracking dashboards.",
      "Client segmentation and conversion analytics.",
      "Property performance and occupancy reports.",
      "Market trend and price forecasting."
    ],
    customerExperience: [
      "Client portal for property search and booking.",
      "Automated confirmations and notifications.",
      "Virtual tours and property galleries.",
      "Custom property recommendations based on preferences."
    ]
  },

  services: [
    {
      title: "Custom Property Management Platform",
      description:
        "Build a platform for property listings, rental management, and real-time availability tracking.",
      deliverables: [
        "Property listing & search engine",
        "Admin dashboard & reporting",
        "Tenant & client portals",
        "Mobile apps for agents and clients"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Real Estate CRM & Client Portal",
      description:
        "Manage leads, client interactions, and property preferences with a dedicated CRM system.",
      deliverables: [
        "Lead tracking & management",
        "Client communication automation",
        "Property preference matching",
        "Automated notifications & reminders"
      ],
      icon: "FaUsersCog",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your platform with listing portals, MLS systems, and payment gateways for seamless operations.",
      deliverables: [
        "API integrations with listing services",
        "Payment gateway & invoicing setup",
        "Automated notifications",
        "Analytics and reporting integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Advanced dashboards to track sales, lead conversion, occupancy, and property performance.",
      deliverables: [
        "Sales & revenue analytics",
        "Lead conversion tracking",
        "Property performance reports",
        "Market trend forecasting"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Property listing & search",
      "Lead tracking & CRM",
      "Automated notifications & workflows",
      "Payment & rent collection",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Virtual tours & 3D galleries",
      "AI-based property recommendations",
      "Mobile apps for agents & clients",
      "Tenant portal & communication",
      "Dynamic pricing & occupancy optimization"
    ]
  },

  integrations: [
    { name: "MLS & Listing Portals (99acres, MagicBricks)", category: "Property Platforms" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "CRM Platforms (Salesforce, Zoho)", category: "Client Management" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Property modules", "CRM APIs", "Admin dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Lead conversion rate",
    "Client satisfaction score",
    "Average deal value",
    "Property occupancy rate",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small real estate agencies",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic property listing module",
        "Lead tracking",
        "Payment gateway integration",
        "Basic reporting"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized agencies & property managers",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom listing modules",
        "CRM & lead automation",
        "Multi-agent access",
        "Advanced analytics & reporting"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large real estate platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full real estate platform",
        "AI-based recommendations",
        "Virtual tours & 3D galleries",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "UrbanNest Realtors",
      location: "Mumbai",
      goals: ["Automate property management", "Increase lead conversion"],
      outcomes: [
        "Property listing updates automated by 80%",
        "Lead conversion improved to 90%",
        "Operational efficiency increased by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Rahul Mehta",
      role: "Founder, UrbanNest Realtors",
      quote:
        "The property management platform transformed our agency. Lead tracking and client engagement are seamless, and our team productivity has improved drastically."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with listing portals and MLS systems?",
      a: "Yes, our platform integrates with major listing portals and MLS systems for real-time property updates."
    },
    {
      q: "Do you provide CRM for client and lead management?",
      a: "Absolutely. Our platform manages client profiles, lead tracking, and automated follow-ups."
    },
    {
      q: "Can this system handle multiple agents and offices?",
      a: "Yes, the platform supports multi-agent roles, permissions, and multi-office setups."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide long-term maintenance, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to digitize your real estate business?",
    text:
      "Let’s build a platform that automates listings, manages leads, and scales your real estate operations efficiently.",
    primaryButton: { label: "Book a Free Real Estate Consultation", href: "/contact?plan=real-estate" },
    secondaryButton: { label: "Download Real Estate Tech Guide", href: "/resources/real-estate-guide.pdf" }
  },

  seo: {
    metaTitle: "Real Estate Software & Property Management Solutions | Optimize Operations",
    metaDescription:
      "We build custom software for real estate agencies and property managers—listing management, CRM, and analytics.",
    keywords: [
      "Real estate software",
      "Property management platform",
      "Listing management system",
      "Real estate CRM",
      "Property analytics"
    ],
    canonical: "https://merndigital.com/industries/real-estate",
    og: {
      title: "Real Estate & Property Management Software Solutions",
      description: "Custom platforms for real estate agencies, property developers, and rental platforms.",
      // image:"https://images.unsplash.com/photo-1560184897-6c3e4a126332?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Real Estate & Property Solutions",
      url: "https://merndigital.com/industries/real-estate",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with listing portals and MLS systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, our platform integrates with major listing portals and MLS systems for real-time property updates."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide CRM for client and lead management?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. Our platform manages client profiles, lead tracking, and automated follow-ups."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/real-estate",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Real Estate & Property Management",
       "item":"https://merndigital.com/industries/real-estate"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 11,
  title: "Education & EdTech Solutions",
  slug: "education",
  segment: "Technology",
  summary:
    "We provide digital solutions for schools, colleges, coaching centers, and online learning platforms—streamlining administration, learning management, student engagement, and analytics with smart software.",
  icon: {
    reactIcons: FaGraduationCap, // education icon
    lucide: "BookOpen"
  },
  brand: {
    color: "#8E24AA",
    accent: "#CE93D8",
    gradient: "linear-gradient(135deg, #8E24AA 0%, #CE93D8 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Education Management",
    subheadline:
      "From school administration to online learning, we help educational institutions optimize operations, engage students, and enhance learning outcomes.",
    highlights: [
      { label: "Student Engagement", value: "90%" },
      { label: "Administrative Efficiency", value: "3x" },
      { label: "Learning Outcome Improvement", value: "60%" }
    ],
    primaryButton: { label: "Book an EdTech Consultation", href: "/contact?src=education" },
    secondaryButton: { label: "See Education Case Studies", href: "/case-studies?industry=education" },
    badge: "For Schools, Colleges, and Online Learning Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1596495577886-d920f1fb2d11?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Education management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1588072432836-e10032774350?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online classroom interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588072433157-1ecce1c2b9b5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "School administration software"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588072433131-6b0d2d9e4cf3?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Learning analytics and progress dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual student records and attendance tracking.",
    "Difficulty managing online and offline courses simultaneously.",
    "Limited insights into student performance and engagement.",
    "High administrative workload for staff and teachers.",
    "Challenges integrating multiple learning platforms and tools.",
    "Slow communication with parents and students."
  ],

  solutions: {
    operations: [
      "Centralized student information system (SIS).",
      "Course and curriculum management.",
      "Automated attendance and grading.",
      "Teacher and staff workflow automation."
    ],
    integrations: [
      "Integration with LMS, video conferencing, and exam platforms.",
      "API integration with payment gateways for fees.",
      "Email and SMS notifications for students and parents.",
      "Integration with analytics and reporting tools."
    ],
    analytics: [
      "Student performance and engagement dashboards.",
      "Attendance and participation analytics.",
      "Course completion and learning outcome reports.",
      "Predictive insights for intervention and support."
    ],
    customerExperience: [
      "Parent and student portals.",
      "Online enrollment and course registration.",
      "Automated notifications and reminders.",
      "Interactive learning and collaboration tools."
    ]
  },

  services: [
    {
      title: "School & College Management Platform",
      description:
        "A platform to manage students, courses, attendance, grading, and administration efficiently.",
      deliverables: [
        "Student information system (SIS)",
        "Attendance & grading modules",
        "Teacher & staff dashboards",
        "Parent & student portals"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Learning Management System (LMS)",
      description:
        "Manage online courses, assignments, and learning resources for students and teachers.",
      deliverables: [
        "Course & curriculum management",
        "Assignment & exam modules",
        "Interactive learning tools",
        "Progress tracking & analytics"
      ],
      icon: "FaChalkboardTeacher",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your platform with LMS, payment systems, video conferencing, and analytics for seamless operations.",
      deliverables: [
        "LMS & exam platform integration",
        "Payment and invoicing setup",
        "Automated alerts & notifications",
        "Analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for student performance, course progress, engagement, and administrative efficiency.",
      deliverables: [
        "Student performance dashboards",
        "Course completion & attendance reports",
        "Teacher & staff productivity analytics",
        "Predictive insights for interventions"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Student information system (SIS)",
      "Attendance & grading automation",
      "Course & curriculum management",
      "Parent & student portals",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Mobile app for students and staff",
      "Interactive learning tools",
      "Automated notifications & reminders",
      "AI-based learning recommendations",
      "Integration with third-party learning platforms"
    ]
  },

  integrations: [
    { name: "LMS & Online Learning Platforms", category: "Learning Management" },
    { name: "Video Conferencing Tools (Zoom, Teams)", category: "Communication" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Student & course modules", "LMS integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Student engagement rate",
    "Course completion rate",
    "Administrative efficiency",
    "Learning outcome improvement",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small schools & coaching centers",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic student management",
        "Course & attendance tracking",
        "Payment integration",
        "Simple dashboards"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium schools & colleges",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom student & course modules",
        "Multi-class & multi-teacher access",
        "Advanced reporting & analytics",
        "Parent & student portal integration"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large institutions & EdTech platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full education management platform",
        "AI-based learning recommendations",
        "Mobile apps for students & staff",
        "Integration with LMS & exam platforms"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Bright Future School",
      location: "Bangalore",
      goals: ["Automate administration", "Enhance student engagement"],
      outcomes: [
        "Attendance automation improved by 80%",
        "Student engagement increased to 90%",
        "Administrative tasks reduced by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Zoom API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Sunita Rao",
      role: "Principal, Bright Future School",
      quote:
        "The EdTech platform streamlined our school operations and significantly improved student engagement. Teachers and staff love the automated workflows."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with LMS and video tools?",
      a: "Yes, our system integrates with major LMS platforms, video conferencing, and exam tools."
    },
    {
      q: "Does it support multiple classes and teachers?",
      a: "Absolutely. Multi-class and multi-teacher access with role-based permissions is fully supported."
    },
    {
      q: "Can parents track student progress?",
      a: "Yes, parent portals provide attendance, grades, and learning progress reports."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we provide long-term maintenance, feature updates, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your educational institution?",
    text:
      "Let’s build a platform that automates administration, engages students, and enhances learning outcomes.",
    primaryButton: { label: "Book a Free EdTech Consultation", href: "/contact?plan=education" },
    secondaryButton: { label: "Download Education Tech Guide", href: "/resources/education-guide.pdf" }
  },

  seo: {
    metaTitle: "Education Software & EdTech Solutions | Optimize Learning & Administration",
    metaDescription:
      "We build custom software for schools, colleges, coaching centers, and EdTech platforms—student management, LMS, analytics, and reporting.",
    keywords: [
      "Education software",
      "EdTech platform",
      "School management system",
      "Learning management system",
      "Student analytics"
    ],
    canonical: "https://merndigital.com/industries/education",
    og: {
      title: "Education & EdTech Software Solutions",
      description: "Custom platforms for schools, colleges, and online learning platforms.",
      // image:"https://images.unsplash.com/photo-1596495577886-d920f1fb2d11?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Education & EdTech Solutions",
      url: "https://merndigital.com/industries/education",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with LMS and video tools?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our system integrates with major LMS platforms, video conferencing, and exam tools."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multiple classes and teachers?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Multi-class and multi-teacher access with role-based permissions is fully supported."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/education",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Education & EdTech Solutions",
       "item":"https://merndigital.com/industries/education"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 12,
  title: "Healthcare & MedTech Solutions",
  slug: "healthcare",
  segment: "Technology",
  summary:
    "We provide digital solutions for hospitals, clinics, diagnostic centers, and healthcare platforms—streamlining patient management, telemedicine, electronic health records, and analytics with smart software.",
  icon: {
    reactIcons: FaHeartbeat, // healthcare icon
    lucide: "Heart"
  },
  brand: {
    color: "#D32F2F",
    accent: "#FFCDD2",
    gradient: "linear-gradient(135deg, #D32F2F 0%, #FFCDD2 100%)",
   
  },

  hero: {
    headline: "Digital Solutions for Smarter Healthcare Management",
    subheadline:
      "From patient management to telemedicine, we help healthcare providers improve operations, patient care, and clinical outcomes.",
    highlights: [
      { label: "Patient Engagement", value: "95%" },
      { label: "Operational Efficiency", value: "3x" },
      { label: "Clinical Outcome Improvement", value: "50%" }
    ],
    primaryButton: { label: "Book a Healthcare Tech Consultation", href: "/contact?src=healthcare" },
    secondaryButton: { label: "See Healthcare Case Studies", href: "/case-studies?industry=healthcare" },
    badge: "For Hospitals, Clinics, and Healthcare Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1588776814546-47c40e48cde1?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Healthcare management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814553-7fc6761f6310?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Telemedicine interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814543-8ffb0712e5e2?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Hospital administration software"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814557-3b7c4c81c872?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Patient health analytics dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual patient records and appointment tracking.",
    "Difficulty managing multiple departments and staff schedules.",
    "Limited visibility into patient outcomes and clinical data.",
    "High administrative workload for healthcare staff.",
    "Challenges integrating multiple hospital and diagnostic systems.",
    "Slow communication with patients and families."
  ],

  solutions: {
    operations: [
      "Centralized patient information system (PIS).",
      "Appointment and scheduling management.",
      "Electronic health record (EHR) automation.",
      "Staff workflow and task management."
    ],
    integrations: [
      "Integration with telemedicine and diagnostic platforms.",
      "API integration with payment and insurance systems.",
      "Email and SMS notifications for patients and staff.",
      "Integration with analytics and reporting tools."
    ],
    analytics: [
      "Patient outcome and engagement dashboards.",
      "Resource and bed utilization analytics.",
      "Clinical KPI and treatment effectiveness reports.",
      "Predictive insights for preventive care."
    ],
    customerExperience: [
      "Patient portals for appointments and reports.",
      "Telemedicine and virtual consultations.",
      "Automated reminders and notifications.",
      "Interactive care and wellness tools."
    ]
  },

  services: [
    {
      title: "Hospital & Clinic Management Platform",
      description:
        "A platform to manage patients, appointments, staff, and clinical operations efficiently.",
      deliverables: [
        "Patient information system (PIS)",
        "Appointment & scheduling modules",
        "Staff dashboards",
        "Patient portals & telemedicine integration"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 300000
    },
    {
      title: "Telemedicine & Patient Engagement System",
      description:
        "Manage virtual consultations, patient communications, and remote monitoring seamlessly.",
      deliverables: [
        "Telemedicine module",
        "Patient notifications & reminders",
        "Online reports & prescriptions",
        "Engagement analytics dashboards"
      ],
      icon: "FaStethoscope",
      duration: "4–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your hospital systems, labs, insurance, and analytics for seamless operations.",
      deliverables: [
        "EHR & lab system integration",
        "Payment & insurance gateway setup",
        "Automated alerts & notifications",
        "Analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for patient outcomes, hospital performance, and clinical insights.",
      deliverables: [
        "Patient engagement & outcome dashboards",
        "Staff productivity reports",
        "Resource utilization analytics",
        "Predictive healthcare insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 150000
    }
  ],

  features: {
    mustHave: [
      "Patient information system (PIS)",
      "Appointment & scheduling automation",
      "Electronic health records (EHR)",
      "Staff & department management",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Telemedicine integration",
      "Predictive care and alerts",
      "Mobile apps for staff and patients",
      "AI-based clinical decision support",
      "Integration with diagnostic and insurance platforms"
    ]
  },

  integrations: [
    { name: "EHR & Hospital Systems", category: "Clinical Operations" },
    { name: "Telemedicine & Virtual Care", category: "Patient Care" },
    { name: "Payment & Insurance Gateways", category: "Finance" },
    { name: "Lab & Diagnostic Platforms", category: "Healthcare Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["HIPAA-compliant encryption", "JWT Auth", "OAuth2"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Patient & staff modules", "Telemedicine integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Patient engagement rate",
    "Appointment adherence",
    "Operational efficiency",
    "Clinical outcome improvement",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small clinics & diagnostic centers",
      priceINR: 200000,
      timeline: "4–6 weeks",
      includes: [
        "Basic patient management",
        "Appointment scheduling",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium hospitals & healthcare networks",
      priceINR: 350000,
      timeline: "6–8 weeks",
      includes: [
        "Custom patient & appointment modules",
        "Multi-department access",
        "Advanced reporting & analytics",
        "Telemedicine integration"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large hospitals & healthcare platforms",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Full healthcare management platform",
        "AI-based predictive care",
        "Mobile apps for patients & staff",
        "Integration with EHR & lab systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Healthy Life Hospital",
      location: "Delhi",
      goals: ["Digitize patient management", "Enable telemedicine"],
      outcomes: [
        "Patient engagement increased to 95%",
        "Appointment adherence improved by 80%",
        "Administrative workload reduced by 40%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Telemedicine API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Dr. Anil Sharma",
      role: "Chief Medical Officer, Healthy Life Hospital",
      quote:
        "The MedTech platform transformed our hospital operations and patient engagement. Staff productivity improved, and patients love the telemedicine features."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with EHR and lab systems?",
      a: "Yes, our platform integrates with major EHR and diagnostic systems for seamless operations."
    },
    {
      q: "Does it support multiple departments and staff roles?",
      a: "Absolutely. Role-based access for multiple departments is fully supported."
    },
    {
      q: "Can patients access their reports online?",
      a: "Yes, patient portals provide secure access to reports, prescriptions, and appointments."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we provide long-term maintenance, feature updates, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your healthcare operations?",
    text:
      "Let’s build a platform that optimizes patient management, telemedicine, and hospital operations.",
    primaryButton: { label: "Book a Free Healthcare Consultation", href: "/contact?plan=healthcare" },
    secondaryButton: { label: "Download Healthcare Tech Guide", href: "/resources/healthcare-guide.pdf" }
  },

  seo: {
    metaTitle: "Healthcare Software & MedTech Solutions | Optimize Patient Care",
    metaDescription:
      "We build custom software for hospitals, clinics, and healthcare platforms—patient management, telemedicine, EHR, and analytics.",
    keywords: [
      "Healthcare software",
      "MedTech platform",
      "Hospital management system",
      "Patient management software",
      "Telemedicine solution"
    ],
    canonical: "https://merndigital.com/industries/healthcare",
    og: {
      title: "Healthcare & MedTech Software Solutions",
      description: "Custom platforms for hospitals, clinics, and healthcare providers.",
      // image:"https://images.unsplash.com/photo-1588776814546-47c40e48cde1?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Healthcare & MedTech Solutions",
      url: "https://merndigital.com/industries/healthcare",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with EHR and lab systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our platform integrates with major EHR and diagnostic systems for seamless operations."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multiple departments and staff roles?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Role-based access for multiple departments is fully supported."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/healthcare",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Healthcare & MedTech Solutions",
       "item":"https://merndigital.com/industries/healthcare"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 13,
  title: "Fashion & Apparel Solutions",
  slug: "fashion-apparel",
  segment: "Lifestyle & Retail",
  summary:
    "We provide digital solutions for fashion brands, retailers, and e-commerce platforms—streamlining inventory management, online stores, design workflows, and customer engagement with smart software.",
  icon: {
    reactIcons: FaTshirt, // fashion icon
    lucide: "ShoppingBag"
  },
  brand: {
    color: "#FF5722",
    accent: "#FFCCBC",
    gradient: "linear-gradient(135deg, #FF5722 0%, #FFCCBC 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Fashion & Apparel Businesses",
    subheadline:
      "From inventory management to e-commerce, we help fashion brands and retailers optimize operations, boost sales, and engage customers.",
    highlights: [
      { label: "Customer Engagement", value: "85%" },
      { label: "Operational Efficiency", value: "2.5x" },
      { label: "Sales Growth", value: "60%" }
    ],
    primaryButton: { label: "Book a Fashion Tech Consultation", href: "/contact?src=fashion-apparel" },
    secondaryButton: { label: "See Fashion Case Studies", href: "/case-studies?industry=fashion-apparel" },
    badge: "For Fashion Brands, Retailers, and E-commerce Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1521335629791-ce4aec67dd45?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Fashion e-commerce dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online fashion store interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521334884684-d80222895322?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Inventory management dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Customer engagement analytics"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual inventory tracking and stock management.",
    "Difficulty managing multiple sales channels.",
    "Limited insights into customer behavior and preferences.",
    "High administrative workload for order fulfillment and logistics.",
    "Challenges integrating e-commerce, POS, and warehouse systems.",
    "Slow marketing campaigns and customer engagement."
  ],

  solutions: {
    operations: [
      "Centralized inventory and order management system.",
      "Automated stock tracking and reordering.",
      "Sales and warehouse workflow automation.",
      "Multi-store and multi-channel management."
    ],
    integrations: [
      "Integration with e-commerce platforms (Shopify, WooCommerce).",
      "POS system integration for offline stores.",
      "Payment gateway and logistics APIs.",
      "Email, SMS, and social media marketing integration."
    ],
    analytics: [
      "Customer behavior and engagement dashboards.",
      "Sales and inventory analytics.",
      "Order fulfillment and delivery performance reports.",
      "Predictive insights for demand and trend forecasting."
    ],
    customerExperience: [
      "Online and mobile store interfaces.",
      "Personalized recommendations and promotions.",
      "Loyalty programs and automated notifications.",
      "Interactive fashion lookbooks and virtual try-ons."
    ]
  },

  services: [
    {
      title: "Fashion E-commerce Platform",
      description:
        "A platform to manage online sales, product catalogs, and customer engagement efficiently.",
      deliverables: [
        "Product catalog & inventory management",
        "Online store setup & customization",
        "Customer dashboards & personalization",
        "Order management & payment integration"
      ],
      icon: "FaShoppingBag",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Inventory & Operations Management",
      description:
        "Manage stock, warehouses, and supply chain operations seamlessly.",
      deliverables: [
        "Inventory tracking & alerts",
        "Warehouse & logistics integration",
        "Multi-store operations dashboards",
        "Automated reordering & stock alerts"
      ],
      icon: "FaWarehouse",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your fashion business with e-commerce platforms, POS, payments, and marketing systems.",
      deliverables: [
        "E-commerce & POS integration",
        "Payment gateway setup",
        "Automated customer notifications",
        "Marketing & analytics integrations"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 100000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for sales, inventory, customer insights, and operational efficiency.",
      deliverables: [
        "Sales & inventory dashboards",
        "Customer behavior analytics",
        "Order fulfillment reports",
        "Trend and demand forecasting"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Product catalog & inventory management",
      "Order & fulfillment automation",
      "Sales analytics & dashboards",
      "Multi-store & multi-channel management",
      "Customer engagement tools"
    ],
    niceToHave: [
      "Mobile app for customers and staff",
      "AI-based product recommendations",
      "Automated marketing & notifications",
      "Virtual try-on & lookbooks",
      "Integration with logistics and POS systems"
    ]
  },

  integrations: [
    { name: "E-commerce Platforms (Shopify, WooCommerce)", category: "Sales Channels" },
    { name: "POS Systems", category: "Offline Retail" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Logistics & Delivery APIs", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Product & inventory modules", "E-commerce integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Online sales growth",
    "Customer engagement rate",
    "Inventory turnover",
    "Operational efficiency",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small boutiques & fashion stores",
      priceINR: 180000,
      timeline: "4–6 weeks",
      includes: [
        "Basic online store",
        "Inventory tracking",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium fashion brands & retail chains",
      priceINR: 320000,
      timeline: "6–8 weeks",
      includes: [
        "Custom product & inventory modules",
        "Multi-store & channel integration",
        "Advanced reporting & analytics",
        "Customer engagement tools"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large fashion brands & e-commerce platforms",
      priceINR: 550000,
      timeline: "8–12 weeks",
      includes: [
        "Full fashion & retail management platform",
        "AI-based product recommendations",
        "Mobile apps for customers & staff",
        "Integration with POS, e-commerce & logistics"
      ]
    }
  ],

  caseStudies: [
    {
      name: "StyleHub Retail",
      location: "Mumbai",
      goals: ["Digitize inventory", "Boost online sales"],
      outcomes: [
        "Online sales increased by 70%",
        "Inventory accuracy improved to 95%",
        "Customer engagement increased by 85%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Shopify API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Riya Kapoor",
      role: "Founder, StyleHub Retail",
      quote:
        "The fashion platform streamlined our operations and boosted online sales. Inventory management and customer engagement tools are a game-changer."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with multiple e-commerce platforms?",
      a: "Yes, we integrate with Shopify, WooCommerce, and other major platforms."
    },
    {
      q: "Does it support multi-store inventory management?",
      a: "Absolutely. You can manage multiple stores, warehouses, and channels from a single dashboard."
    },
    {
      q: "Can customers access personalized recommendations?",
      a: "Yes, AI-based recommendations and promotions can be displayed on your store."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to digitize your fashion business?",
    text:
      "Let’s build a platform that optimizes operations, boosts sales, and engages your customers.",
    primaryButton: { label: "Book a Free Fashion Tech Consultation", href: "/contact?plan=fashion-apparel" },
    secondaryButton: { label: "Download Fashion Tech Guide", href: "/resources/fashion-guide.pdf" }
  },

  seo: {
    metaTitle: "Fashion & Apparel Software Solutions | Optimize Retail & E-commerce",
    metaDescription:
      "We build custom software for fashion brands and retailers—inventory management, e-commerce, analytics, and customer engagement.",
    keywords: [
      "Fashion software",
      "Retail management system",
      "E-commerce platform",
      "Inventory management",
      "Customer engagement tools"
    ],
    canonical: "https://merndigital.com/industries/fashion-apparel",
    og: {
      title: "Fashion & Apparel Software Solutions",
      description: "Custom platforms for fashion brands, retailers, and e-commerce businesses.",
      // image:"https://images.unsplash.com/photo-1521335629791-ce4aec67dd45?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Fashion & Apparel Solutions",
      url: "https://merndigital.com/industries/fashion-apparel",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with multiple e-commerce platforms?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we integrate with Shopify, WooCommerce, and other major platforms."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multi-store inventory management?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. You can manage multiple stores, warehouses, and channels from a single dashboard."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/fashion-apparel",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Fashion & Apparel Solutions",
       "item":"https://merndigital.com/industries/fashion-apparel"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 15,
  title: "Automotive Solutions",
  slug: "automotive",
  segment: "Transportation & Mobility",
  summary:
    "We provide digital solutions for automotive manufacturers, dealerships, and mobility services—streamlining vehicle inventory, sales, service management, and connected vehicle analytics with smart software.",
  icon: {
    reactIcons: FaCar, // automotive icon
    lucide: "Car"
  },
  brand: {
    color: "#1976D2",
    accent: "#BBDEFB",
    gradient: "linear-gradient(135deg, #1976D2 0%, #BBDEFB 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Automotive Businesses",
    subheadline:
      "From dealership management to connected vehicle analytics, we help automotive brands and service providers optimize operations, enhance customer experiences, and boost sales.",
    highlights: [
      { label: "Inventory Accuracy", value: "95%" },
      { label: "Operational Efficiency", value: "2.5x" },
      { label: "Sales Growth", value: "40%" }
    ],
    primaryButton: { label: "Book an Automotive Tech Consultation", href: "/contact?src=automotive" },
    secondaryButton: { label: "See Automotive Case Studies", href: "/case-studies?industry=automotive" },
    badge: "For Automotive Manufacturers, Dealerships, and Mobility Services"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Automotive management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Vehicle inventory dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1549921296-3a03c18d99c3?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Dealer sales and service management"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1571607388905-d6f3cbf693e5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Connected car analytics dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual tracking of vehicle inventory and sales.",
    "Difficulty managing multiple dealerships or branches.",
    "Limited insights into customer preferences and buying behavior.",
    "High administrative workload for service scheduling and parts management.",
    "Challenges integrating CRM, sales, and service systems.",
    "Slow reporting on sales, inventory, and service performance."
  ],

  solutions: {
    operations: [
      "Centralized vehicle inventory and sales management.",
      "Automated service scheduling and parts tracking.",
      "Workflow automation for dealerships and service centers.",
      "Multi-branch and multi-dealer management."
    ],
    integrations: [
      "Integration with CRM and ERP systems.",
      "Payment gateway integration for vehicle purchases and service.",
      "Service and parts supplier APIs.",
      "Marketing automation for customer engagement."
    ],
    analytics: [
      "Sales and inventory dashboards.",
      "Customer and vehicle lifecycle analytics.",
      "Service and parts performance reports.",
      "Predictive insights for demand and maintenance scheduling."
    ],
    customerExperience: [
      "Online vehicle booking and test-drive scheduling.",
      "Personalized offers and promotions.",
      "Automated notifications for service and sales.",
      "Connected vehicle dashboards and mobile apps."
    ]
  },

  services: [
    {
      title: "Dealership & Inventory Management",
      description:
        "Manage vehicles, inventory, and sales efficiently across multiple branches.",
      deliverables: [
        "Vehicle database & inventory tracking",
        "Sales dashboards & reporting",
        "Multi-branch management",
        "Automated stock alerts & reordering"
      ],
      icon: "FaWarehouse",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Service & Maintenance Management",
      description:
        "Manage vehicle service scheduling, parts, and customer communications seamlessly.",
      deliverables: [
        "Service booking & scheduling system",
        "Parts inventory management",
        "Automated customer notifications",
        "Service analytics & reports"
      ],
      icon: "FaTools",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect dealership software with CRM, ERP, payment gateways, and analytics tools.",
      deliverables: [
        "CRM & ERP integration",
        "Payment gateway setup",
        "Automated notifications & reminders",
        "Reporting & analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for sales, inventory, service, and customer insights.",
      deliverables: [
        "Sales & inventory dashboards",
        "Service and parts reports",
        "Customer behavior analytics",
        "Predictive maintenance insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 140000
    }
  ],

  features: {
    mustHave: [
      "Vehicle inventory management",
      "Sales & service dashboards",
      "Multi-branch dealership management",
      "Customer engagement & CRM integration",
      "Service scheduling & parts tracking"
    ],
    niceToHave: [
      "Connected vehicle dashboards",
      "Mobile app for customers & staff",
      "AI-based sales & service predictions",
      "Automated marketing & promotions",
      "Integration with third-party analytics & ERP"
    ]
  },

  integrations: [
    { name: "CRM Systems (Salesforce, Zoho)", category: "Sales & Customer Management" },
    { name: "ERP & Inventory Systems", category: "Operations" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Service & Parts Supplier APIs", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Inventory modules", "Service & sales integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Vehicle inventory accuracy",
    "Sales growth & conversion rate",
    "Service efficiency & turnaround",
    "Customer satisfaction score",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small dealerships & garages",
      priceINR: 200000,
      timeline: "4–6 weeks",
      includes: [
        "Basic inventory & sales management",
        "Service scheduling",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium-sized dealerships & automotive businesses",
      priceINR: 350000,
      timeline: "6–8 weeks",
      includes: [
        "Advanced inventory & sales modules",
        "Multi-branch management",
        "Service & parts tracking",
        "Analytics & reporting dashboards"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large automotive chains & manufacturers",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Full automotive management platform",
        "Connected vehicle analytics",
        "Mobile apps for customers & staff",
        "Integration with ERP, CRM & analytics tools"
      ]
    }
  ],

  caseStudies: [
    {
      name: "AutoHub Dealership",
      location: "Pune",
      goals: ["Digitize inventory management", "Improve service operations"],
      outcomes: [
        "Inventory accuracy improved by 95%",
        "Service turnaround time reduced by 30%",
        "Sales conversion increased by 25%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "ERP API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Rajesh Verma",
      role: "Operations Manager, AutoHub Dealership",
      quote:
        "The platform streamlined our inventory, sales, and service operations. Our efficiency and customer satisfaction have greatly improved."
    }
  ],

  faqs: [
    {
      q: "Can this platform manage multiple dealership branches?",
      a: "Yes, you can manage inventory, sales, and service across multiple branches from a single dashboard."
    },
    {
      q: "Does it support connected vehicle analytics?",
      a: "Yes, the platform can integrate with connected vehicle systems to provide real-time insights."
    },
    {
      q: "Can we automate service scheduling and notifications?",
      a: "Absolutely, the system automates service bookings, reminders, and parts management."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to digitize your automotive operations?",
    text:
      "Let’s build a platform that manages inventory, sales, service, and connected vehicle analytics efficiently.",
    primaryButton: { label: "Book a Free Automotive Tech Consultation", href: "/contact?plan=automotive" },
    secondaryButton: { label: "Download Automotive Tech Guide", href: "/resources/automotive-guide.pdf" }
  },

  seo: {
    metaTitle: "Automotive Software Solutions | Dealership & Vehicle Management",
    metaDescription:
      "We build custom software for automotive businesses—inventory, sales, service management, connected vehicle analytics, and customer engagement.",
    keywords: [
      "Automotive software",
      "Dealership management system",
      "Vehicle inventory management",
      "Service & maintenance software",
      "Connected vehicle analytics"
    ],
    canonical: "https://merndigital.com/industries/automotive",
    og: {
      title: "Automotive Software Solutions",
      description: "Custom platforms for automotive manufacturers, dealerships, and mobility services.",
      // image:"https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Automotive Solutions",
      url: "https://merndigital.com/industries/automotive",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform manage multiple dealership branches?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can manage inventory, sales, and service across multiple branches from a single dashboard."
          }
        },
        {
          "@type": "Question",
          name: "Does it support connected vehicle analytics?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, the platform can integrate with connected vehicle systems to provide real-time insights."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/automotive",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Automotive Solutions",
       "item":"https://merndigital.com/industries/"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 22,
  title: "Construction & Home Services Solutions",
  slug: "construction-home-services",
  segment: "Websites, SEO & Marketing for Contractors and Home Service Providers",
  summary:
    "We help construction companies, contractors, and home service businesses attract more clients with modern websites, local SEO, and digital marketing campaigns.",
  icon: {
    reactIcons: FaTools, // construction icon
    lucide: "Hammer"
  },
  brand: {
    color: "#FF9800",
    accent: "#FFE0B2",
    gradient: "linear-gradient(135deg, #FF9800 0%, #FFE0B2 100%)",
    
  },

  hero: {
    headline: "Build Your Construction & Home Services Brand",
    subheadline:
      "From contractor websites to local SEO campaigns, we create solutions that attract new clients and grow your business.",
    highlights: [
      { label: "Leads Growth", value: "70%" },
      { label: "Local SEO Visibility", value: "85%" },
      { label: "Customer Retention", value: "40%" }
    ],
    primaryButton: { label: "Book a Free Consultation", href: "/contact?src=construction-home-services" },
    secondaryButton: { label: "See Case Studies", href: "/case-studies?industry=construction" },
    badge: "For Contractors, Builders, Renovators & Home Services"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Construction and home services website design",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1621905251918-5696b6c74a6e?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Contractor website with project showcase"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Home services booking platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Renovation business website"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty generating local leads and referrals.",
    "Outdated websites that don’t inspire trust.",
    "No system for online booking or inquiries.",
    "Low visibility in Google Maps & local search.",
    "Manual project tracking and client communication.",
    "High dependency on word-of-mouth referrals."
  ],

  solutions: {
    operations: [
      "Modern contractor websites with service showcases.",
      "Online booking & inquiry systems.",
      "Project portfolio galleries.",
      "Mobile-friendly design for homeowners."
    ],
    integrations: [
      "Payment gateways for service deposits.",
      "CRM for lead management.",
      "Scheduling & calendar tools.",
      "WhatsApp & email notifications."
    ],
    analytics: [
      "Leads & conversions dashboard.",
      "Local SEO performance tracking.",
      "Campaign ROI reports.",
      "Customer review & satisfaction tracking."
    ],
    customerExperience: [
      "Easy service booking online.",
      "Mobile-first user experience.",
      "Transparent pricing pages.",
      "Automated updates & reminders."
    ]
  },

  services: [
    {
      title: "Contractor Website Development",
      description:
        "We design professional websites that showcase your services, past projects, and help you win more clients.",
      deliverables: [
        "Custom branding",
        "Service pages",
        "Project portfolio",
        "SEO optimization"
      ],
      icon: "FaGlobe",
      duration: "2–4 weeks",
      startingPriceINR: 65000
    },
    {
      title: "Local SEO & PPC Campaigns",
      description:
        "Dominate Google Maps and local search results with targeted SEO and ad campaigns.",
      deliverables: [
        "Google My Business optimization",
        "Local keywords targeting",
        "PPC campaigns",
        "Monthly reports"
      ],
      icon: "FaBullhorn",
      duration: "3–6 months",
      startingPriceINR: 50000
    },
    {
      title: "Booking & Inquiry Systems",
      description:
        "Allow customers to request quotes, book services, and schedule appointments online.",
      deliverables: [
        "Inquiry forms",
        "Online booking calendar",
        "Payment integration",
        "CRM sync"
      ],
      icon: "FaCalendarCheck",
      duration: "3–5 weeks",
      startingPriceINR: 60000
    },
    {
      title: "Digital Marketing for Home Services",
      description:
        "Attract new clients with content marketing, paid ads, and social media campaigns.",
      deliverables: [
        "Facebook & Instagram ads",
        "Content strategy",
        "Lead funnels",
        "Performance tracking"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 80000
    }
  ],

  features: {
    mustHave: [
      "SEO-friendly contractor website",
      "Service inquiry & booking forms",
      "Google My Business setup",
      "Portfolio/project showcase",
      "Mobile-first design"
    ],
    niceToHave: [
      "Online service payments",
      "Chatbot for inquiries",
      "Loyalty & referral programs",
      "WhatsApp/SMS notifications",
      "Virtual consultations"
    ]
  },

  integrations: [
    { name: "Zoho CRM / HubSpot", category: "CRM" },
    { name: "Google My Business", category: "SEO & Local" },
    { name: "Stripe / Razorpay", category: "Payments" },
    { name: "Calendly / Booksy", category: "Booking" },
    { name: "Meta Ads / Google Ads", category: "Marketing" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Hotjar", "Meta Ads Manager"],
    security: ["SSL", "Secure Payment APIs", "User Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Target service areas", "SEO audit", "Business goals"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Website design", "Booking system", "SEO setup"] },
    { step: 3, title: "Marketing Setup", duration: "3–4 weeks", outputs: ["Local SEO", "Ad campaigns", "Content plan"] },
    { step: 4, title: "Testing & Launch", duration: "1 week", outputs: ["Mobile testing", "Booking flow QA", "SEO audit"] },
    { step: 5, title: "Ongoing Growth", duration: "Continuous", outputs: ["Lead reports", "Campaign optimization", "Support"] }
  ],

  kpis: [
    "Local search visibility",
    "New leads generated",
    "Website conversion rate",
    "Project inquiries",
    "ROI from digital ads"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Individual Contractors",
      priceINR: 50000,
      timeline: "2–3 weeks",
      includes: [
        "Basic contractor website",
        "Local SEO setup",
        "Google My Business profile",
        "Contact/inquiry form"
      ]
    },
    {
      tier: "Growth",
      audience: "Small Construction Firms",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Advanced website with portfolio",
        "SEO & PPC campaigns",
        "Booking & inquiry system",
        "Monthly performance reports"
      ]
    },
    {
      tier: "Premium",
      audience: "Large Contractors & Multi-city Firms",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Comprehensive online presence",
        "Multi-location SEO",
        "Advanced CRM integration",
        "Full-scale marketing campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "BuildRight Contractors",
      location: "Delhi",
      goals: ["Generate more project inquiries", "Rank higher in local search", "Showcase past projects"],
      outcomes: [
        "70% increase in local leads in 4 months",
        "Top 3 ranking on Google Maps for 10+ keywords",
        "Professional website with 50+ project showcases"
      ],
      stack: ["Next.js", "Node.js", "Google My Business", "Meta Ads", "Zoho CRM"]
    }
  ],

  testimonials: [
    {
      author: "Arjun Singh",
      role: "Owner, BuildRight Contractors",
      quote:
        "Mern Digital transformed our online presence. We now get consistent inquiries from Google, and our portfolio site impresses clients."
    }
  ],

  faqs: [
    {
      q: "Can you help us rank higher in local search?",
      a: "Yes, we specialize in local SEO strategies to get you into Google’s top results and Maps listings."
    },
    {
      q: "Do you build websites for small contractors?",
      a: "Absolutely, we design scalable websites for solo contractors as well as large firms."
    },
    {
      q: "Can you set up online booking?",
      a: "Yes, we integrate booking and inquiry systems to make it easy for clients to request services online."
    },
    {
      q: "Do you provide digital marketing services?",
      a: "Yes, we run PPC, SEO, and social media campaigns tailored to home services and construction businesses."
    }
  ],

  cta: {
    title: "Ready to Get More Construction Leads?",
    text:
      "Let’s build a powerful online presence with a website, SEO, and marketing strategy designed to grow your construction or home service business.",
    primaryButton: { label: "Get a Free Demo", href: "/contact?plan=construction-home-services" },
    secondaryButton: { label: "Download Construction Marketing Guide", href: "/resources/construction-guide.pdf" }
  },

  seo: {
    metaTitle: "Construction & Home Services | Websites, SEO & Marketing",
    metaDescription:
      "We build websites, booking systems, and local SEO campaigns to help contractors and home service providers attract more clients.",
    keywords: [
      "construction marketing",
      "contractor website design",
      "local SEO for builders",
      "home services marketing",
      "digital marketing for contractors"
    ],
    canonical: "https://merndigital.com/industries/construction-home-services",
    og: {
      title: "Construction & Home Services Solutions",
      description: "Websites, booking & marketing to grow your construction and home service business.",
      // image:"https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Construction & Home Services Solutions",
      url: "https://merndigital.com/industries/construction-home-services",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you help with local SEO for contractors?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in Google Maps optimization and local SEO to increase leads."
          }
        },
        {
          "@type": "Question",
          name: "Can you build booking systems for home services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we integrate booking and inquiry tools so clients can easily schedule services."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/construction-home-services",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Construction & Home Services",
        "item":"https://merndigital.com/industries/construction-home-services"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},

];
export default industries;